function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Fragment } from 'react';
import theme from '@adsk/alloy-react-theme';
import Line from './Line';
const AutomaticAboutBoxContent = _ref => {
  let {
    collections
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, collections === null || collections === void 0 ? void 0 : collections.map(collection => /*#__PURE__*/React.createElement(Fragment, {
    key: collection.type
  }, /*#__PURE__*/React.createElement(Line, {
    style: _objectSpread(_objectSpread({}, theme.typography.heading4), {}, {
      marginTop: 20
    })
  }, "The following components are licensed under ", collection.type, ' ', "license:"), collection.licenses.map((license, i) => {
    let author;
    if (typeof license.author === 'string') {
      author = license.author;
    } else if (typeof license.author === 'object') {
      author = license.author.name;
    } else {
      author = license.repository;
    }
    return /*#__PURE__*/React.createElement("div", {
      key: license.name + i
    }, /*#__PURE__*/React.createElement(Line, {
      style: theme.typography.labelMedium
    }, license.name), /*#__PURE__*/React.createElement(Line, {
      style: _objectSpread(_objectSpread({}, theme.typography.labelSmall), {}, {
        marginTop: 0
      })
    }, "Copyright ", author), !collection.attribution && /*#__PURE__*/React.createElement(Line, null, license.licenseText));
  }), collection.attribution && /*#__PURE__*/React.createElement(Line, null, collection.attribution))));
};
export default AutomaticAboutBoxContent;
//# sourceMappingURL=AutomaticAboutBoxContent.js.map